import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`

#___gatsby{
  display: flex; 
  flex-direction: column; 
  flex-grow: 1;
}
#gatsby-focus-wrapper{
    width:100vw;
    max-width:100%;
    margin:0;
    padding:0;
    height:100vh;
    max-height:100%;
  }
  :root {
    --mov: #C62BD2;
    --mov-feed: #BC5CDF;
    --mov-button: #7F6CDE;
    --green-profile: #3FD0DB;
    --green-smiley: #EAFBFC;
    --pink-smiley: #FEF0FF;
    --gray: #6c757d;
    --gray-dark: #343a40;
    --blue-500: #3D84FF;
    --gray-shadow: rgba(66,74,123,0.1);
    --red-button: #CD5C5C;
    --yellow: #ffc600;
    --black: #272727;
   /* putem defini ce culori vrem noi */
    --white: white;
    --text-color: var(--gray-dark);
    --focus-ring-color: var(--blue-500);
    --box-shadow:var(--gray-shadow)
    --background:#f4f4f5;
    --mobile: 1000px;
  }
  /* https://css-tricks.com/simplified-fluid-typography/ */
  /* link-ul de mai sus arata f n=bune cum se seteaza fluid typography */
  /* clamp(min, desired, maximum) */
  html, body {
      margin: 0;
      padding: 0;

      font-size: clamp(100%, 1rem + 2vw, 24px);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', "Segoe UI", 'Quicksand', "Oxygen",sans-serif;  
    
} 

  *,
  *::after,
  *::before {
    box-sizing: inherit;
  }
  
  body {
      width: 100vw;
      max-width: 100%;
      padding:0;
      margin:0;
      background: white;
      color: var(--text-color); 
      font-size: clamp(100%, 1rem + 2vw, 24px);
      font-family:-apple-system, BlinkMacSystemFont, 'Helvetica Neue', "Segoe UI", 'Quicksand', "Oxygen",sans-serif;  
      text-rendering: optimizeLegibility;
      .tooltiptext{
        color: white;
        font-size: .5rem;
      }
      .ant-tooltip-inner {
        border-radius: 6px;
        background-color: var(--blue-500);
    }
  }
  h1{
    font-family:-apple-system, BlinkMacSystemFont, 'Helvetica Neue', "Segoe UI", 'Quicksand', "Oxygen",sans-serif;  
  }
  h5{
    font-family:-apple-system, BlinkMacSystemFont, 'Helvetica Neue', "Segoe UI", 'Quicksand', "Oxygen",sans-serif;  
  font-size:.7rem;
  }
  p{
    margin-block-start:0;
    margin-block-end: 0;
    margin-inline-end: 0;
    font-family:-apple-system, BlinkMacSystemFont, 'Helvetica Neue', "Segoe UI", 'Quicksand', "Oxygen",sans-serif;  
    color: var(--text-color); 
  }
  
    a {
      color: var(--text-color);
      text-decoration: none;
    }  

    ul{
      list-style: none;
      margin: 0;
      padding: 0;
    }
    button{
        color: var(--text-color);
        background: var(--blue-500);
        border: 0.5px solid var(--blue-500);
        border-radius: 3px;
        padding: 6px 16px;
        font-size: .7rem;
    }    
    .gdpr{
      margin: auto 4rem;
      a{
        color: blue;
      }
    }
`
